/**
 * Dark Mode 完整逻辑
 * 从 layout/theme.liquid 移出，defer 加载
 * 最小化防闪烁逻辑保留在 <head> 中内联执行
 */

let cscoDarkMode = {};

(function () {
  const body = document.querySelector('html[data-scheme]');

  cscoDarkMode = {
    init: function (e) {
      this.initMode(e);
      this.bindToggleButtons(document);

      // init() 会在 Theme Editor section 重载时再次调用；系统监听只需要一份。
      if (!this.systemListenerBound) {
        this.systemListenerBound = true;
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
          this.initMode(event);
        });
      }
    },

    // 可重复调用。移动抽屉的按钮首次打开时才从 template 插入，不能只在 load 时扫一次。
    bindToggleButtons: function (root) {
      const scope = root || document;
      scope.querySelectorAll('.header__toggle-scheme').forEach((btn) => {
        if (btn.dataset.darkModeBound) return;
        btn.dataset.darkModeBound = '1';
        btn.addEventListener('click', (event) => {
          event.preventDefault();

          if ('auto' === body.getAttribute('data-scheme')) {
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
              cscoDarkMode.changeScheme('light', true);
            } else if (window.matchMedia('(prefers-color-scheme: light)').matches) {
              cscoDarkMode.changeScheme('dark', true);
            }
          } else if ('dark' === body.getAttribute('data-scheme')) {
            cscoDarkMode.changeScheme('light', true);
          } else {
            cscoDarkMode.changeScheme('dark', true);
          }
        });
      });
    },

    initMode: function (e) {
      let siteScheme = false;

      switch (window.__themeColorScheme) {
        case 'dark':
          siteScheme = 'dark';
          break;
        case 'light':
          siteScheme = 'light';
          break;
        case 'system':
          siteScheme = 'auto';
          break;
      }

      if (window.__themeDarkModeToggle) {
        const saved = localStorage.getItem('_color_schema');
        if ('light' === saved) siteScheme = 'light';
        if ('dark' === saved) siteScheme = 'dark';
      }

      if (siteScheme && siteScheme !== body.getAttribute('data-scheme')) {
        this.changeScheme(siteScheme, false);
      }
    },

    changeScheme: function (siteScheme, cookie) {
      body.classList.add('scheme-toggled');
      body.setAttribute('data-scheme', siteScheme);
      if (cookie) {
        localStorage.setItem('_color_schema', siteScheme);
      }
      setTimeout(() => {
        body.classList.remove('scheme-toggled');
      }, 100);
    },
  };
})();

cscoDarkMode.init();

// global.js 在移动抽屉正文真正插入后发出该事件。
document.addEventListener('menu-drawer:hydrated', function (event) {
  cscoDarkMode.bindToggleButtons(event.detail && event.detail.drawer);
});

// Shopify 主题编辑器中 section 重载时重新初始化
document.addEventListener('shopify:section:load', function () {
  setTimeout(() => {
    cscoDarkMode.init();
  }, 100);
});
